export const mapCoverageStatus = (isActive: boolean): string =>
  isActive ? "Active" : "Inactive";

export default mapCoverageStatus;
